// extracted by mini-css-extract-plugin
export default {"wrapper":"Eq-z","response":"Fq-z","error":"Gq-z","disabled":"Hq-z","buttons":"Iq-z","feedbackQuestionSection":"Jq-z","yesNoWrapper":"Kq-z"};